__turbopack_context__.v({
  "activity-link-span": "styles-module__u62s-W__activity-link-span",
  "text-responsive": "styles-module__u62s-W__text-responsive",
});
